import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

interface BulkTemplateCopyRequest {
	destinationAccountId: string;
	templateReferences: string[];
	additionalKeywords?: string[];
}

interface TemplateCopyResult {
	sourceAccountId: string;
	sourceTemplateId: string;
	newTemplateId?: string;
	templateName?: string;
	success: boolean;
	error?: string;
}

interface BulkTemplateCopyResponse {
	results: TemplateCopyResult[];
}

export const useTemplateBulkCopyMutation = ({
	onError,
	onSuccess,
}: {
	onSuccess?: (data: BulkTemplateCopyResponse) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (request: BulkTemplateCopyRequest) => {
			return userSession.webServiceHelper.callAsync<BulkTemplateCopyResponse>(
				'admin/template/bulkCopy',
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};

export type { BulkTemplateCopyRequest, TemplateCopyResult, BulkTemplateCopyResponse };
